import { atom } from 'jotai';
import { reduxAtom } from '../../../../jotai/redux-atoms';

interface QuickFiltersState {
	desiredVenueSetting: QuickFilter[];
}

export interface QuickFilter {
	label: string;
	facetId: string;
}

export const quickFiltersInitialState: QuickFiltersState = {
	desiredVenueSetting: [],
};

export const quickFiltersAtom = atom<QuickFiltersState>(
	quickFiltersInitialState,
);

export const guestCapacityAtom = atom<QuickFilter | undefined>((get) => {
	const state = get(reduxAtom);
	const label = state.membership.member?.number_of_guests;
	if (!label) {
		return undefined;
	}
	const guestCapacityFilter = state.search.filters.filters.find(
		(filter) => filter.slug === 'guest_capacity',
	);
	const facetId =
		guestCapacityFilter?.filterOptions.find((option) => option.name === label)
			?.id || '';
	return { label, facetId };
});

export const desiredVenueSettingAtom = atom(
	(get) => get(quickFiltersAtom).desiredVenueSetting,
	(get, set, desiredVenueSetting: QuickFilter[]) => {
		set(quickFiltersAtom, {
			...get(quickFiltersAtom),
			desiredVenueSetting,
		});
	},
);
